import 'src/theme/global.css';
import 'src/scss/main.scss';
import wrapWithProvider from './wrap-with-provider';
import wrapWithLayout from './wrap-with-layout';
import { v1 as uuidv1 } from 'uuid';
import { axiosGet } from 'utils/api-utils';
import { environment } from 'utils/envConfig';
import logError from 'utils/errorHandler';

import { setStorage, getStorage } from 'utils/storageManager';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = wrapWithLayout;

const initLogRocket = () => {
  if (window.LogRocket && !window.LogRocket._isInitialized) {
    window.LogRocket.init('yibjp2/lg-prod', { release: 'lettucegrow-' + process.env.GATSBY_APP_VERSION });
  }
};

// app initially mounts
export const onInitialClientRender = () => {
  const lgUserId = getStorage('lgClientId');
  if (!lgUserId) {
    // TODO: save storage key as a constant (different branch currently)
    setStorage('lettucegrow-newUser', true);
    setStorage('lgClientId', uuidv1());
  } else {
    setStorage('lettucegrow-newUser', false);
  }
  axiosGet('/app/public/hello', { headers: { url: window?.location?.href } });
  if (environment === 'production') {
    initLogRocket();
    window.addEventListener('error', logError);
  }
};

// fires when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (window !== undefined) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'optimize.pagechange' });

    //notify the Sidekick of the route update
    window.Gladly?.navigate?.();
  }
};
